import { render, staticRenderFns } from "./DescriptionList.vue?vue&type=template&id=f98c6cba&"
import script from "./DescriptionList.vue?vue&type=script&lang=ts&"
export * from "./DescriptionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports